import { useCallback } from 'react';
import { Button } from '@od-rwa/ui';
import { BrandMark } from '@/components/ui/brand-mark';

/**
 * Reloading fetches the current build, almost always the fix when a deploy
 * replaced the file a page asked for.
 */
export function RouteError() {
  const handleReload = useCallback(() => window.location.reload(), []);

  return (
    <main
      className="bg-surface-1 text-fg-1 grid min-h-dvh place-items-center px-6 text-center"
      data-testid="route-error"
    >
      <div className="grid justify-items-center gap-5">
        <BrandMark size="header" />
        <p className="font-display m-0 text-xl uppercase">Something went wrong</p>
        <p className="text-fg-2 m-0 max-w-sm">Reload the page and it should be back.</p>
        <Button
          size="lg"
          type="button"
          onClick={handleReload}
        >
          Reload
        </Button>
      </div>
    </main>
  );
}
